import { createResultsApi } from "@/v2/api/metadata/results";
import { createSportsApi } from "@/v2/api/metadata/sports";
import type { BackofficeContext } from "@/v2/framework/context/types";
import type { EntityView } from "@/v2/framework/view/types";
import { columns, dynamicColumnSlots } from "./columns";
import { createFilters } from "./filters";
import { createDialogs } from "./dialogs";

const LS_SPORTS_FILTERS_KEY = Symbol("sports-filters");

export function createSportsView(ctx: BackofficeContext): EntityView {
  const sportsApi = createSportsApi(ctx);
  const resultsApi = createResultsApi(ctx);

  return {
    id: "sports",
    view: [
      {
        type: "grid",
        columns,
        filters: createFilters({ ctx }),
        dynamicColumnSlots,
        dialogs: createDialogs({ ctx, sportsApi, resultsApi }),
        syncRouteQuery: true,
        syncRouteDialog: true,
        hasExport: true,
        filtersKey: LS_SPORTS_FILTERS_KEY,
        allowSaveFilters: true,
        hasSearch: true,
        api: sportsApi.grid,
      },
    ],
  };
}
